import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LaunchIcon from "@mui/icons-material/Launch";

// InfoBox component for highlighted information
const InfoBox = ({
  title,
  content,
  type = "info",
  icon,
  link,
  linkText = "Learn More",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const getIcon = () => {
    if (icon) return icon;
    switch (type) {
      case "warning":
        return <WarningIcon />;
      case "success":
        return <CheckCircleOutlineIcon />;
      default:
        return <InfoIcon />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case "warning":
        return "#fff3e0";
      case "success":
        return "#e8f5e9";
      case "primary":
        return "#e3f2fd";
      default:
        return "#f5f5f5";
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case "warning":
        return "#ffb74d";
      case "success":
        return "#81c784";
      case "primary":
        return "#90caf9";
      default:
        return "#e0e0e0";
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        my: 2,
        backgroundColor: getBackgroundColor(),
        borderLeft: `4px solid ${getBorderColor()}`,
        borderRadius: 1,
      }}
    >
      <Box display="flex" alignItems="flex-start">
        <Box
          sx={{
            mr: 2,
            color: getBorderColor(),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pt: 0.5,
          }}
        >
          {getIcon()}
        </Box>
        <Box sx={{ width: "100%" }}>
          {title && (
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              fontWeight="medium"
              gutterBottom
            >
              {title}
            </Typography>
          )}
          <Typography variant="body2" sx={{ color: "text.primary" }}>
            {content}
          </Typography>

          {link && (
            <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
              <Button
                startIcon={<LaunchIcon />}
                variant="contained"
                sx={{
                  backgroundColor: "#4ABDAC",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#2D93AD",
                    color: "#fff",
                  },
                }}
                component={RouterLink}
                to={link}
              >
                {linkText}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default InfoBox;
